import log from 'salvo-lite/log'

class YouTubePlayer {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._elem = elem
        this.playable = false
        this._events = ['yt-api-loaded', 'yt-player-ready']
        this.player = null
        this._attr = {
            id: this._elem.id || `videoPlayer${Math.floor(Math.random() * 9999)}`
        }
        this._settings = {
            autoplay: true,
            loop: false,
            playlist: elem.dataset.youtubePlayer,
            ytScript: 'https://www.youtube.com/iframe_api',
            videoId: elem.dataset.youtubePlayer
        }
        this._elem.id = this._elem.id || this._attr.id
        this._elem.dataset.componentId = this._elem.dataset.componentId || this._attr.id
    }

    onInit () {
        this._createEvents()
        this.youtubeScript()
        log.debug(this._name, 'Initiated', this)
    }

    init () {
        document.dispatchEvent(this._events['yt-api-loaded'])
        this.player = new window.YT.Player(this._elem.id, {
            videoId: this._settings.videoId,
            events: {
                'onReady': evt => this._onPlayerReady(evt),
                'onStateChange': evt => this._onStateChange(evt)
            }
        })
    }

    playVideo (loop) {
        this._settings.loop = loop || this._settings.loop
        this.player.playVideo()
    }

    pauseVideo () {
        this.player.pauseVideo()
    }

    _createEvents () {
        let tempObj = {}
        for (let evt of this._events) {
            tempObj[evt] = new Event(evt)
        }
        this._events = tempObj
    }

    _onPlayerReady (evt) {
        this._events['yt-player-ready'].player = this.player
        this._elem.dispatchEvent(this._events['yt-player-ready'])
    }

    _onStateChange (evt) {
        if (evt.data === window.YT.PlayerState.ENDED && this._settings.loop) {
            this.player.playVideo()
        }
    }

    youtubeScript () {
        let ytScript = document.querySelector("script[src='https://www.youtube.com/iframe_api']")
        if (ytScript) return ytScript
        ytScript = document.createElement('script')
        ytScript.src = this._settings.ytScript
        let firstScriptTag = document.getElementsByTagName('script')[0]
        firstScriptTag.parentNode.insertBefore(ytScript, firstScriptTag)
        window.onYouTubeIframeAPIReady = () => this.init()
    }
}

export default YouTubePlayer



// WEBPACK FOOTER //
// ./src/scripts/components/YouTubePlayer.js